import axios from 'axios';
import { getToken } from '../utils/auth';
import api from '../../../config/api';
// eslint-disable-next-line import/prefer-default-export
export const AuthService = {
	async login(user) {
		try {
			const res = await axios
				.post(
					`${process.env.REACT_APP_API_ENDPOINT}auth/signon`,
					user,
					{
						'Content-Type': 'application/json',
						timeout: 20000,
					},
				)
				.then((response) => response)
				.catch((err) => {
					// eslint-disable-next-line no-console
					console.log(err);
					return {
						status: err.response.status,
						data: null,
					};
				});
			return res;
		} catch (e) {
			return {
				status: 500,
				data: null,
			};
		}
	},

	async logout(token) {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				accept: 'application/json',
				'Content-Type': 'application/json',
			},
			timeout: 20000,
		};
		const res = await axios
			.delete(`${process.env.REACT_APP_API_ENDPOINT}auth/logout`, config)
			.then((response) => response)
			.catch((err) => ({
				status: err.response?.status ? err.response?.status : 500,
				data: null,
			}));

		return res;
	},

	async checkDoubleAuthCode(code, mfaToken) {
		if (code === null || mfaToken === null) return false;
		const config = {
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
			},
		};

		const res = await axios
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}auth/mfa/${mfaToken}`,
				{ code },
				config,
			)
			.then((response) => response)
			.catch((err) => ({
				status: err.response?.status ? err.response?.status : 500,
				data: null,
			}));
		return res;
	},
	loginWithSSO(code) {
		const config = {
			headers: {
				accept: 'application/json',
				'Content-Type': 'application/json',
			},
		};

		const data = {
			code,
		};
		return axios.post(
			`${process.env.REACT_APP_API_ENDPOINT}auth/sso`,
			data,
			config,
		);
	},
	refreshToken(token, refreshToken) {
		const config = {
			headers: {
				Authorization: `Bearer ${token}`,
				accept: 'application/json',
				'Content-Type': 'application/json',
			},
			timeout: 20000,
		};

		const data = {
			refresh_token: refreshToken,
		};
		return axios.post(
			`${process.env.REACT_APP_API_ENDPOINT}auth/token/refresh`,
			data,
			config,
		);
	},
	async modifyPassword(data) {
		const token = getToken();
		const resp = await axios
			.patch(
				`${process.env.REACT_APP_API_ENDPOINT}auth/change-password`,
				data,
				{
					headers: {
						Authorization: `Bearer ${token}`,
						Accept: 'application/json',
					},
					'Content-Type': 'application/json',
					timeout: 20000,
				},
			)
			.then((response) => response)
			.catch((err) => {
				// eslint-disable-next-line no-console
				console.log(err);
				return {
					status: err.response.status,
					data: err.response.data,
				};
			});
		return resp;
	},
	async resetPassword(data, token) {
		const resp = await axios
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}auth/reset-password/${token}`,
				data,
				{
					headers: {
						'Content-Type': 'application/json',
					},
					timeout: 20000,
				},
			)
			.then((response) => response)
			.catch((err) => ({
				status: err.response.status,
				data: err.response.data,
			}));
		return resp;
	},
	async callResetLink(data) {
		const token = getToken();
		const resp = await axios
			.post(
				`${process.env.REACT_APP_API_ENDPOINT}auth/reset-password`,
				data,
				{
					headers: {
						'Content-Type': 'application/json',
					},
					timeout: 20000,
				},
			)
			.then((response) => response)
			.catch((err) => {
				// eslint-disable-next-line no-console
				console.log('err', err);
				return {
					status: err.response.status,
					data: err.response.data,
				};
			});
		return resp;
	},
};
